import axios from 'axios';
import {api} from '../utils/helper';

//****************** GET All Daily Entries by Date ******************//
export const dailyEntryData = async (a) => {
    try{
     // const a = { orgID: sessionStorage.getItem('org'), projID: sessionStorage.getItem('project')}
    const resrep = await axios.post(
      `${api}/dailyEntryData`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );
//          console.log(`dailyEntryData controller res: `, resrep);
          return resrep;
    }catch (error) {
//        console.log(`dailyEntryData controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}